import { API_ENDPOINTS } from '../constants/api-endpoints';
import { useApiService } from '../../dsha-api';

export class UserService {
    constructor (apiService) {
        this.apiService = apiService;
    }

    getWellnessHour ({ userId }) {
        return this.apiService.get({
            path: API_ENDPOINTS.WELLNESS_HOUR,
            urlParams: { userId }
        }).then(r => r.data.hourId);
    }

    setWellnessHour ({ userId, hourId }) {
        return this.apiService.post({
            path: API_ENDPOINTS.WELLNESS_HOUR,
            urlParams: { userId },
            payload: { hourId }
        }).then(r => r.data);
    }
}

export const useUserService = () => useApiService(UserService);
